import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import EventInProgressListContainer from '../../views/event/inProgessList/EventInProgressListContainer';
import { EVENT_PAGE_NAME } from '../../constants/service/app/eventConstants';

const EventInProgressList = () => {
  return (
    <PageTemplate pageName={EVENT_PAGE_NAME.EVENT_IN_PROGRESS_LIST}>
      <EventInProgressListContainer />
    </PageTemplate>
  );
};

export default EventInProgressList;
